module.exports = __webpack_public_path__ + "static/media/Screen_Shot_1.d556e6b4.png";